// extracted by mini-css-extract-plugin
module.exports = {"socialIcon":"socialMediaIcon-module--socialIcon--Ws7Ve","socialIconContainer":"socialMediaIcon-module--socialIconContainer--1d-tb"};